module.exports = __webpack_public_path__ + "img/Welhaven_Johan_Sebastian_Welhaven.0f7837ea.jpg";